/**
 * Refund Channel Values for select in History Refund
 * @type {{DOMISERVE: string, CRCESU: string}}
 */
export const RefundChannelSelectValues = {
    REMISE_SIMPLE: "Remise simple",
    REMISE_CODE_BARRE: "Remise par code barre",
    REMISE_FICHIER: "Remise par fichier",
    REMISE_BENEFICIAIRE: "Remise par bénéficiaire",
    REMISE_MANUELLE: "Remise manuelle par Domiserve",
    AUTRES: "Autres",
}
